import { useEffect, useState } from "react";
import { useWallet } from "../context/WalletContext";
import { useUserStore } from "../stores/useUserStore";
import { BASE_URL } from "../utils/constants";
// import "../styles/WalletTabs.css";

const WalletTabs = () => {
  const [activeTab, setActiveTab] = useState("refs");
  const { account, networkId, isConnected, connectWallet, disconnectWallet } = useWallet();
  const [isValidReferral, setIsValidReferral] = useState(false);
   const referral = useUserStore((s) => s.referral);
   const rewards = useUserStore((s) => s.rewards);
   const setUser = useUserStore((s) => s.setUser);
   const [copied, setCopied] = useState(false);

   const handleCopy = async () => {
    if (referral) {
      const link = `${BASE_URL}/?ref=${referral}`;
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); 
    }
  };


  return (
    <div className="wallet-tabs">
      {/* Tab Buttons */}
      <div className="tab-buttons">
        {["refs", "staking", "mining"].map((tab) => (
          <button
            key={tab}
            className={`btn tab-button ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "refs" && (
          <div className="tab-panel fs-13px">
            { 
              !referral ? (<>
                <p className="mg-b-3px">You must hold at least 100,000 $HYPER to participate. </p>
                {/* <hr /> */}
              </>) : (
                <>
                  <p className="mg-b-3px bg-color-primary">{BASE_URL}/?ref={referral}</p>
                  <button className="btn btn-sm btn-success btn-w-100p" onClick={handleCopy}> {copied ? "Copied!" : "Copy"}</button>
                  <hr />
                  <h6 className="mg-b-8px">Bounus</h6>
                 
                  {rewards ? rewards!.map((reward, index) => (
                      <p key={index} className="mg-b-3px">+{reward.bounus} $HYPER From 
                        <a href={`https://bscscan.com/tx/${reward.tx}`} target="__blank"> TX</a>
                      </p>
                  )) : <p></p>}
                  
                </>
              )
            }


          </div>
        )}
        {activeTab === "staking" && (
          <div className="tab-panel">
            <h6>Coming Soon</h6>
          </div>
        )}
        {activeTab === "mining" && (
          <div className="tab-panel">
            <h6>Coming Soon</h6>
          </div>
        )}
        {/* {activeTab === "actives" && (
          <div className="tab-panel">
            <p>actives</p>
          </div>
        )} */}

      </div>
    </div>
  );
};

export default WalletTabs;
